var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIotTemperatureSensor(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.97,
    height: 33.787,
    viewBox: "0 0 15.97 33.787",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.5 0.524)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3256.061,324.1c0-3.16-.013-6.321,0-9.481a3.458,3.458,0,0,1,3.107-3.472,3.4,3.4,0,0,1,3.582,2.382,5.955,5.955,0,0,1,.2,1.677q.019,9.075,0,18.148a1.584,1.584,0,0,0,.489,1.232,5.522,5.522,0,0,1-.115,7.733,5.469,5.469,0,0,1-7.791-7.675,1.749,1.749,0,0,0,.539-1.359C3256.049,330.219,3256.061,327.157,3256.061,324.1Zm1.2.369c0,3.161-.009,6.321.009,9.481a1.314,1.314,0,0,1-.518,1.189,4.037,4.037,0,0,0-1.552,3.373,4.331,4.331,0,0,0,3.493,4.137,4.407,4.407,0,0,0,4.74-2.389,4.156,4.156,0,0,0-1.094-5.148,1.364,1.364,0,0,1-.536-1.186c.017-6.394.005-12.789.017-19.183a2.235,2.235,0,0,0-1.384-2.24,2.282,2.282,0,0,0-3.17,2.263C3257.252,318,3257.264,321.23,3257.264,324.464Z",
    transform: "translate(-3254.004 -311.114)",
    fill: "#36a4ff",
    stroke: "#417eba",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3258.451,327.994q0-3.3,0-6.594a3.333,3.333,0,0,1,.051-.735.955.955,0,0,1,1-.809.9.9,0,0,1,1,.792,11.681,11.681,0,0,1,.073,1.7c0,4.1.01,8.2-.006,12.3a1.076,1.076,0,0,0,.588,1.12,3.026,3.026,0,0,1,1.347,3.524,3.124,3.124,0,0,1-6-.059,3.018,3.018,0,0,1,1.394-3.5.971.971,0,0,0,.554-.988C3258.438,332.489,3258.451,330.241,3258.451,327.994Z",
    transform: "translate(-3254.004 -311.114)",
    fill: "#36a4ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3265.133,328.5l3.593-.753a.312.312,0,0,0-.008-.612l-3.614-.649a1.026,1.026,0,0,0-1.207,1.01h0A1.026,1.026,0,0,0,3265.133,328.5Z",
    transform: "translate(-3254.004 -311.114)",
    fill: "#36a4ff",
    stroke: "#417eba",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3265.133,321.055l3.593-.753a.312.312,0,0,0-.008-.612l-3.614-.648a1.025,1.025,0,0,0-1.207,1.009h0A1.025,1.025,0,0,0,3265.133,321.055Z",
    transform: "translate(-3254.004 -311.114)",
    fill: "#36a4ff",
    stroke: "#417eba",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3265.133,317.333l3.593-.753a.312.312,0,0,0-.008-.612l-3.614-.649a1.026,1.026,0,0,0-1.207,1.01h0A1.026,1.026,0,0,0,3265.133,317.333Z",
    transform: "translate(-3254.004 -311.114)",
    fill: "#36a4ff",
    stroke: "#417eba",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3265.133,324.777l3.593-.752a.312.312,0,0,0-.008-.613l-3.614-.648a1.025,1.025,0,0,0-1.207,1.009h0A1.025,1.025,0,0,0,3265.133,324.777Z",
    transform: "translate(-3254.004 -311.114)",
    fill: "#36a4ff",
    stroke: "#417eba",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIotTemperatureSensor);
export default __webpack_public_path__ + "static/media/iotTemperatureSensor.4dea2a7e0464d6778b15a92e4a751596.svg";
export { ForwardRef as ReactComponent };